export const ROUTES = {
  default: "/home",
  home: "/home",
  signIn: "/signIn",
};
